import React from 'react';
import { usePrefs, useLabels, useRequestData } from 'wsm-common-data';
import { useSelector } from 'react-redux';
import {
	estimatedDeliveryDate,
	estimatedDeliveryFee
} from 'wsm-delivery-estimation';
import DeliveryDate from './DeliveryDate';
import DeliveryFee from './DeliveryFee';

const Delivery = () => {
	const labels = useLabels();
	const {
		deliveryMax,
		deliveryBaseCost,
		baseDeliveryRadius,
		deliveryCostPerMile,
		deliveryDateMilesPerDay,
		deliveryDateMinimumDays
	} = usePrefs();
	const distance = useSelector((state) => state.distance.distance);
	const { hours } = useSelector((state) => state.location);
	const { locale } = useRequestData();

	if (distance === null || distance === undefined) {
		return null;
	}

	const deliveryMaxValue = parseInt(deliveryMax, 10);
	const isDeliveryUnavailable =
		(!Number.isNaN(deliveryMaxValue) && distance > deliveryMaxValue) ||
		!hours ||
		Object.values(hours).every((value) => value.toLowerCase() === 'closed');

	if (isDeliveryUnavailable) {
		return (
			<strong className="pr-4">
				{labels.get('DELIVERY_NOT_AVAILABLE')}
			</strong>
		);
	}

	const deliveryFee = estimatedDeliveryFee(
		distance,
		deliveryBaseCost,
		baseDeliveryRadius,
		deliveryCostPerMile
	);

	const deliveryDate = estimatedDeliveryDate(
		distance,
		locale,
		deliveryDateMilesPerDay,
		deliveryDateMinimumDays,
		hours
	);

	if (deliveryFee === null || !deliveryDate) {
		return null;
	}

	return (
		<span className="pr-4">
			<DeliveryFee deliveryFee={deliveryFee} />
			<DeliveryDate deliveryDate={deliveryDate} />
		</span>
	);
};

export default Delivery;
